<template>
  <div class="cp-material">
    <input type="text" class="name" v-model="name" />
    <input type="number" class="phone" v-model="phone" />
    <textarea class="address" rows="4" v-model="address" />
    <div v-if="showErr" class="error">{{msg}}</div>
    <div class="action" @click="handleAddress"></div>
    <Close is-mobile @close="handleClose" class="close"></Close>
  </div>
</template>

<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import Close from '~/components/Close/close.vue';
import Alert from "~/components/Alert";
import { mapState } from "vuex";
import api from "~/api/api";

export default {
  name: 'material',
  components: {Close},
  props: {
    material: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      name: '',
      phone: '',
      address: '',
      showErr: false,
      msg: '请将姓名，手机号，地址填写完整'
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.name = this.userInfo.rname || '';
      this.phone = this.userInfo.rmobile || '';
      this.address = this.userInfo.address || '';
    })
  },
  methods: {
    onCopy: function (e) {
      Alert('复制成功~')
    },
    onError: function (e) {
      Alert('复制失败!')
    },
    handleClose() {
      store.commit(types.HIDE_MODAL2);
    },
    checkForm() {
      if(!this.name || !this.phone || !this.address) {
        this.showErr = true
        this.msg = '请将姓名，手机号，地址填写完整'
        return false
      }
      if(this.phone && !/^1\d{10}$/.test(this.phone)) {
        this.showErr = true
        this.msg = "请输入正确的手机号码"
        return false
      }
      this.showErr = false
      return true
    },
    handleAddress() {
      if(!this.checkForm() || this.loading) {
        return
      }
      let data = {rname: this.name, rmobile: this.phone, addr: this.address}
      this.loading = true
      api.saveAddr({rname: this.name, rmobile: this.phone, addr: this.address}).then(res => {
        if(res.status === 1) {
          store.commit(types.UPDATE_USER, Object.assign({}, this.userInfo, data, {address: this.address}));
        }
        store.commit(types.HIDE_MODAL2);
      }).finally(() => {
        this.loading = false
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
  .cp-material
    position absolute
    width 6.66rem
    height 9.62rem
    background-image url('./images/address.png')
    background-size: 6.66rem 8.92rem;
    background-repeat: no-repeat;
    background-position 0 0
    line-height 1.5
    .action
      position absolute
      top 7.1rem
      left 50%
      margin-left -1.16rem
      width 2.32rem
      height 0.86rem
      background-image url('./images/confirm.png')
      background-size: 100% 100%;
      background-repeat: no-repeat;
    .error
      font-size 0.22rem
      color #b42d00
      line-height 1
      position absolute
      top 6.74rem
      left 1.1rem
    .name
      position absolute
      top 2.03rem
      left 1.84rem
      width 4.05rem
      height 0.8rem
      font-size 0.24rem
      line-height 0.8rem
    .phone
      position absolute
      top 3.18rem
      left 2.08rem
      width 3.81rem
      height 0.8rem
      font-size 0.24rem
      line-height 0.8rem
    .address
      position absolute
      top 4.95rem
      left 1.13rem
      width 4.65rem
      height 1.47rem
      font-size 0.24rem

@keyframes fadeIn {
  from {
    opacity 0
  }
  to {
    opacity: 1
  }
}
</style>
